import type { SortKey } from "@/types/video";

interface SortBarProps {
  sortKey: SortKey;
  onChange: (key: SortKey) => void;
  total: number;
  viewMode: "page" | "more";
  onViewModeChange: (mode: "page" | "more") => void;
}

const options: { key: SortKey; label: string }[] = [
  { key: "popular", label: "按热门" },
  { key: "recent", label: "按更新时间" },
  { key: "rating", label: "按评分" },
];

export default function SortBar({ sortKey, onChange, total, viewMode, onViewModeChange }: SortBarProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-background-200 bg-background-100 px-3 py-2.5 md:px-4">
      <p className="text-sm text-foreground-600">
        共找到 <span className="font-bold text-accent-600">{total}</span> 部影视作品
      </p>
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-1 rounded-full bg-background-50 p-1">
          {options.map((option) => (
            <button
              key={option.key}
              type="button"
              onClick={() => onChange(option.key)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
                sortKey === option.key
                  ? "bg-primary-600 text-background-50"
                  : "text-foreground-600 hover:text-primary-600"
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
        <div className="hidden items-center gap-1 rounded-full bg-background-50 p-1 sm:flex">
          <button
            type="button"
            onClick={() => onViewModeChange("page")}
            className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
              viewMode === "page" ? "bg-secondary-600 text-background-50" : "text-foreground-600 hover:text-secondary-700"
            }`}
          >
            分页
          </button>
          <button
            type="button"
            onClick={() => onViewModeChange("more")}
            className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
              viewMode === "more" ? "bg-secondary-600 text-background-50" : "text-foreground-600 hover:text-secondary-700"
            }`}
          >
            加载更多
          </button>
        </div>
      </div>
    </div>
  );
}